import { render } from "./viewTrustDetails.vue?vue&type=template&id=00da43e9"
import script from "./viewTrustDetails.vue?vue&type=script&lang=js"
export * from "./viewTrustDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__